module.exports = __webpack_public_path__ + "media/admin/cs_publication_004_sm-411ffeb8.png";